import { CityLocationFeature, DistrictLocationFeature } from '../components/map/iConsumerMap';

const districtStyleFunction = (feature: DistrictLocationFeature | undefined) => {
  const district = feature?.properties.district || '';
  const intensity = Math.min(district.length / 10, 1);
  return {
    fillColor: `rgba(0, 76, 211, ${intensity})`,
    fillOpacity: 0.6,
    color: '#fff',
    weight: 1,
  };
};

const districtBorderStyleFunction = (feature: DistrictLocationFeature | undefined) => {
  return {
    fillOpacity: 0,
    weight: 2,
    color: `rgba(0, 76, 211, ${0.8})`,
  };
};

const cityStyleFunction = (feature: CityLocationFeature | undefined) => {
  const city = feature?.properties.city || '';
  const intensity = Math.min(city.length / 10, 1);
  return {
    fillColor: `rgba(0, 76, 211, ${intensity})`,
    fillOpacity: 0.6,
    color: '#fff',
    weight: 1,
  };
};

const getColorByIntensity = (value: number, max: number, min: number = 0) => {
  // rangedIntensity is from 0 to 1
  const rangedIntensity = (value - min) / (max - min);
  return `rgba(0, 76, 211, ${rangedIntensity})`;
};

const normalizeString = (name: string | undefined) =>
  (name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '')
    .toLowerCase();

export {
  districtStyleFunction,
  districtBorderStyleFunction,
  cityStyleFunction,
  normalizeString,
  getColorByIntensity,
};
